import React, { useState } from 'react';
import { Col, Input, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import '@ant-design/compatible/assets/index.css';
import { testEmpty, formatMoney } from '@iso/lib/helpers/utility';
import { testNumber } from '../scripts/utils';
import MoneyInput from '@iso/components/MoneyInput.js';

export default function ValueInputs(props) {

    const [item, setItem] = useState({})
    const [itemIdx, setItemIdx] = useState(null)

    React.useEffect(() => {

        let aux = {...props.currentTableItem};

        aux.subtotal = testNumber(aux.price) * aux.qtd;

        setItem(aux);
        setItemIdx(props.currentTableItemIdx);
    }, [props.currentTableItem])

    const onChangeVal = (f, v) => {
        setItem(prev => {
            prev[f] = v;
            props.onChange('item', prev, itemIdx);

            prev.price = testNumber(prev.price)

            if(typeof prev.discount !== 'undefined')
                prev.discount = testNumber(prev.discount)
            if(typeof prev.addition !== 'undefined')
                prev.addition = testNumber(prev.addition)

            prev.subtotal = prev.qtd * prev.price

            prev.total = prev.subtotal - testNumber(prev.discount) + testNumber(prev.addition);
            return prev;
        })
    }

    return (
        <Row gutter={24} className='contentItemEditInputs'>
            <Col span={12}>Quantidade:</Col>
            <Col span={12}>
                <Input type='number' value={item.qtd} className='textRight' onChange={(e)=> { onChangeVal('qtd', parseInt(e.target.value)) }} />
            </Col>
            <Col span={12}>Preço:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="price"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(item.price)}
                    // onChange={(e) => onChangeVal('price', e.target.value ) }
                />
            </Col>
            <Col span={12}>Sub total:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="subtotal"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(item.subtotal)}
                />
            </Col>
            <Col span={12}>Desconto:</Col>
            <Col span={12}>
                <MoneyInput
                    name="discount"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(item.discount, ''))}
                    onChange={(e) => onChangeVal('discount', e.target.value ) }
                    disabled={ props.settings?.discount_permission === 'N' ? true : false }
                />
            </Col>
            <Col span={12}>Acréscimo:</Col>
            <Col span={12}>
                <MoneyInput
                    name="addition"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(item.addition, ''))}
                    onChange={(e) => onChangeVal('addition', e.target.value ) }
                    disabled={ props.settings?.discount_permission === 'N' ? true : false }
                />
            </Col>
            <Col span={12}>Total líquido:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="total"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(item.total)}
                />
            </Col>
            <Col span={12}>Observações:</Col>
            <Col span={12}>
                <TextArea rows={5} value={ testEmpty(item.obs, '') } onChange={(e) => onChangeVal('obs', e.target.value ) }/>
            </Col>
        </Row>
    )
}